export const WORDS = [
  'don cheadle',
]
